import { resolveUrl } from '@wix/sdk-runtime/rest-modules';
import { ResolveUrlOpts } from '@wix/sdk-runtime/rest-modules';
import { RequestOptionsFactory } from '@wix/sdk-types';

function resolveWixSocialGroupsApiV2GroupRolesServiceUrl(
  opts: Omit<ResolveUrlOpts, 'domainToMappings'>
) {
  const domainToMappings = {
    'api._api_base_domain_': [
      {
        srcPath: '/roles-proxy',
        destPath: '',
      },
    ],
    _: [
      {
        srcPath: '/_api/roles-proxy',
        destPath: '',
      },
      {
        srcPath: '/_api/social-groups-proxy/roles',
        destPath: '',
      },
    ],
    '*.dev.wix-code.com': [
      {
        srcPath: '/_api/social-groups-proxy/roles',
        destPath: '',
      },
    ],
    'editor-flow.wixapps.net': [
      {
        srcPath: '/_api/social-groups-proxy/roles',
        destPath: '',
      },
    ],
    'editor._base_domain_': [
      {
        srcPath: '/_api/social-groups-proxy/roles',
        destPath: '',
      },
    ],
    'blocks._base_domain_': [
      {
        srcPath: '/_api/social-groups-proxy/roles',
        destPath: '',
      },
    ],
    'create.editorx': [
      {
        srcPath: '/_api/social-groups-proxy/roles',
        destPath: '',
      },
    ],
    'editor.wixapps.net': [
      {
        srcPath: '/_api/social-groups-proxy/roles',
        destPath: '',
      },
    ],
    'groups.wixapps.net': [
      {
        srcPath: '/_api/social-groups-proxy/roles',
        destPath: '',
      },
    ],
    'manage._base_domain_': [
      {
        srcPath: '/_api/social-groups-proxy/roles',
        destPath: '',
      },
      {
        srcPath: '/social-groups-proxy/api/roles',
        destPath: '',
      },
    ],
    'www._base_domain_': [
      {
        srcPath: '/_api/social-groups-proxy/roles',
        destPath: '',
      },
    ],
    'www.wixapis.com': [
      {
        srcPath: '/social-groups-proxy/roles',
        destPath: '',
      },
    ],
  };

  return resolveUrl(Object.assign(opts, { domainToMappings }));
}

const PACKAGE_NAME = '@wix/auto_sdk_groups_roles';

/**
 * Assigns a specific role to group members.
 *
 * Calling this method overrides the group member's current `role.value`.
 *
 * >**Notes:**
 * > + Only group admins can assign roles.
 * > + You cannot create new members with this method.
 */
export function assignRole(payload: object): RequestOptionsFactory<any> {
  function __assignRole({ host }: any) {
    const metadata = {
      entityFqdn: 'wix.social_groups.v2.group_role',
      method: 'POST' as any,
      methodFqn: 'wix.social.groups.api.v2.GroupRolesService.AssignRole',
      packageName: PACKAGE_NAME,
      migrationOptions: {
        optInTransformResponse: true,
      },
      url: resolveWixSocialGroupsApiV2GroupRolesServiceUrl({
        protoPath: '/v2/groups/{groupId}/roles/assign',
        data: payload,
        host,
      }),
      data: payload,
    };

    return metadata;
  }

  return __assignRole;
}

/**
 * Unassigns a role from group members.
 *
 * You can only unassign `ADMIN` roles. Calling this method with group members
 * with `role.value` set to `MEMBER` returns an error.
 *
 * > **Notes:**
 * > + Only group admins can assign roles.
 * > + You cannot remove members with this method.
 */
export function unassignRole(payload: object): RequestOptionsFactory<any> {
  function __unassignRole({ host }: any) {
    const metadata = {
      entityFqdn: 'wix.social_groups.v2.group_role',
      method: 'POST' as any,
      methodFqn: 'wix.social.groups.api.v2.GroupRolesService.UnassignRole',
      packageName: PACKAGE_NAME,
      migrationOptions: {
        optInTransformResponse: true,
      },
      url: resolveWixSocialGroupsApiV2GroupRolesServiceUrl({
        protoPath: '/v2/groups/{groupId}/roles/unassign',
        data: payload,
        host,
      }),
      data: payload,
    };

    return metadata;
  }

  return __unassignRole;
}
